// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__+uklo","spinner1":"Spinner_spinner1__t8TnT","spinner2":"Spinner_spinner2__3dGtr","spinner3":"Spinner_spinner3__7FkMv"};